import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "../css/style.css";
import logo from "../assets/image/rccglogo.webp";
import { ToastContainer } from "react-toastify";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();

    if (!email.trim()) {
      toast.error("Email address field is required", { theme: "colored" });
      return;
    }

    setLoading(true);
    try {
      const TEST_BASE_URL = process.env.REACT_APP_BASE_URL;
      const res = await fetch(`${TEST_BASE_URL}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      let data;
      const contentType = res.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        data = await res.json();
      } else {
        const text = await res.text();
        console.error("Server returned non-JSON response:", text);
        toast.error("Unexpected server response. Please try again.", {
          theme: "colored",
        });
        setLoading(false);
        return;
      }

      if (!res.ok) {
        if (
          data.message?.toLowerCase().includes("not found") ||
          data.message?.toLowerCase().includes("not registered")
        ) {
          toast.error("Email not registered.", { theme: "colored" });
        } else if (data.message) {
          toast.error(data.message, { theme: "colored" });
        } else {
          toast.error("Password reset request failed.", { theme: "colored" });
        }
      } else {
        toast.success("6 digit OTP has been sent to your Email.", {
          theme: "colored",
        });

        localStorage.setItem("resetEmail", email);

        setTimeout(() => {
          navigate("/reset-password");
        }, 1500);
      }
    } catch (err) {
      console.error(err);
      toast.error("Network error — please try again.", { theme: "colored" });
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <section className="login">
        <div className="containerfluid">
          <div className="row loginrow">
            <div className="col-md-6">
              <div className="loginbg">
                <img src={logo} alt="RCCG Logo" />
                <h5 className="py-5">
                  Welcome to RCCG New Beginning Chapel, Bournemouth, UK
                </h5>
                <p className="text-white">
                  RCCG Bournemouth Membership Portal has been built to create a
                  community where the church members can interact with each
                  other seamlessly.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <form className="card" onSubmit={handleSubmit}>
                <h5>Forgot Password</h5>
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="form-control"
                />

                <a href="/" className="arrowlink">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="10"
                    viewBox="0 0 18 12"
                    fill="none"
                  >
                    <path
                      d="M0.999983 6.00024L17 6.00024"
                      stroke="#040404"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M5.99996 1C5.99996 1 1.00001 4.68244 1 6.00004C0.999988 7.31763 6 11 6 11"
                      stroke="#040404"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span> Back to Login</span>
                </a>

                <button type="submit" disabled={loading}>
                  {loading ? "Sending..." : "Reset Password"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer position="top-right" autoClose={1500} />
    </>
  );
}
